import store from '@user-center/store'
import {
  addition,
  subtraction,
  multiplication,
  division,
} from "@user-center/utils/common";
import {get,isArray,isObject,isString} from 'lodash-es'
export function checkIsQianKunSite() {
  return false;
}


export function isMallApp() {
  return false;
}

export function isMallAppApi() {
   
  return !! get(store, 'state.app.storeInfoData.offiaccountFollowData.otherJson.mallApiUrl');
}

export function isDisabledMallSsr(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return String((window as any)?.__NUXT__?.config?.public?.disabledMallSsr ?? "")
    .trim()
    .toLowerCase() === "true";
}

export function normalizeMallApiBaseUrl(rawUrl = ""): string {
  let nextUrl = String(rawUrl || "").trim();
  if (!nextUrl) {
    return "";
  }

  nextUrl = nextUrl.replace(/\/+$/, "");
  nextUrl = nextUrl.replace(/\/mall$/i, "");

  if (typeof window !== "undefined") {
    if (window.location.protocol === "http:" && nextUrl.indexOf("https://") === 0) {
      nextUrl = nextUrl.replace("https://", "http://");
    } else if (window.location.protocol === "https:" && nextUrl.indexOf("http://") === 0) {
      nextUrl = nextUrl.replace("http://", "https://");
    }
  }

  return nextUrl.replace(/\/+$/, "");
}

export function getStoreOtherJson(): Record<string, any> {
  const readOtherJson = (storeInfoData: Record<string, any> = {}) => {
    const directOtherJson = get(storeInfoData, 'offiaccountFollowData.otherJson');
    if (directOtherJson && typeof directOtherJson === "object") {
      return directOtherJson;
    }

    const rawOtherJson = get(storeInfoData, 'offiaccountFollowUrlData.otherJson')
      || get(storeInfoData, 'otherJson');

    if (rawOtherJson && typeof rawOtherJson === "object") {
      return rawOtherJson;
    }

    if (typeof rawOtherJson === "string") {
      try {
        return JSON.parse(rawOtherJson) || {};
      } catch (error) {
        return {};
      }
    }

    return {};
  };

  const storeInfoData = get(store, 'state.app.storeInfoData', {}) || {};
  const storeOtherJson = readOtherJson(storeInfoData);
  if (Object.keys(storeOtherJson).length) {
    return storeOtherJson;
  }

  try {
    const storeInformationText = getBrowserStorage()?.getItem("StoreInformation") || "";
    const storeInformation = storeInformationText ? JSON.parse(storeInformationText) : {};
    if (typeof storeInformation?.offiaccountFollowUrl === "string" && !storeInformation.offiaccountFollowData) {
      storeInformation.offiaccountFollowData = JSON.parse(storeInformation.offiaccountFollowUrl || "{}") || {};
    }
    if (
      storeInformation?.offiaccountFollowData
      && typeof storeInformation.offiaccountFollowData.otherJson === "string"
    ) {
      storeInformation.offiaccountFollowData.otherJson = JSON.parse(
        storeInformation.offiaccountFollowData.otherJson || "{}",
      ) || {};
    }
    return readOtherJson(storeInformation);
  } catch (error) {
    return {};
  }
}

export function getMallApiBaseUrl(): string {
  const mallApiUrl = getStoreOtherJson()?.mallApiUrl;
  return normalizeMallApiBaseUrl(mallApiUrl || "");
}

function getBrowserStorage(): Storage | null {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  if (typeof localStorage !== "undefined") {
    return localStorage;
  }
  return null;
}


export const mallAppKey="mall_app_user_key"
export const mallAppCurrentUserDataKey="mall_app_user_info"

export function setMallAppToken(val){
  getBrowserStorage()?.setItem(mallAppKey,val)
}

export function setCurrentUserInfo(val){
  getBrowserStorage()?.setItem(mallAppCurrentUserDataKey,val)
}


export function getCurrentUserInfo(){
 return getBrowserStorage()?.getItem(mallAppCurrentUserDataKey) || null
}
export function getMallAppToken(){
 return getBrowserStorage()?.getItem(mallAppKey) || null
}


export function checkMallFetchUrl(url:string):boolean {
  const normalizedUrl = String(url || "").trim();
  if (!normalizedUrl) {
    return false;
  }

  return normalizedUrl.indexOf('mall=1') >= 0
    || /^\/?mall\//i.test(normalizedUrl)
    || /^\/?mallSite\//i.test(normalizedUrl)
    || /^\/?storeSite\//i.test(normalizedUrl);
}


export function getMallUserInfoData():boolean {
  return get(store,'getters.userInfo.mallUserInfo',{})
}


export function findDeepValText(currentItem = {}, findKeys = [], transferList = []):void{
  // 递归查找翻译的中文
  findKeys.map((keys) => {
    keys.map((key, keyIx) => {
      let selectItem = get(currentItem, key);
      if (isArray(selectItem)) {
        selectItem.map((o) => {
          if(isObject(o)){
            findDeepValText(o, [keys.slice(keyIx + 1)], transferList);
          }else{
            transferList.push(o);
          }
        });
      } else if (isObject(selectItem)) {
        findDeepValText(selectItem, [keys.slice(keyIx + 1)], transferList);
      } else if (isString(selectItem)) {
        transferList.push(selectItem);
      }
    });
  });
}



export function getCurrencySymbol(defaultSymbol) {
  const currentCurrencyStr = getBrowserStorage()?.getItem("currentCurrency");
  let currentCurrency = null;
  try {
    currentCurrency = JSON.parse(currentCurrencyStr);
  } catch (e) {
    console.log(e);
  }
  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return defaultSymbol;
  }
  return currentCurrency &&
    (currentCurrency.shortCode ||
      currentCurrency.symbol ||
      currentCurrency.toCurrencyCode)
    ? currentCurrency.symbol ||
        currentCurrency.shortCode ||
        currentCurrency.toCurrencyCode
    : defaultSymbol;
}

export function getCurrencyNum(num) {
  const currentCurrencyStr = getBrowserStorage()?.getItem("currentCurrency");
  let currentCurrency = null;
  try {
    currentCurrency = JSON.parse(currentCurrencyStr);
  } catch (e) {
    console.log(e);
  }

  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return num;
  }
  if (typeof num == "string") {
    num = Number(num);
  }
  return currentCurrency && currentCurrency.exchangeRate && !isNaN(num)
    ? multiplication(currentCurrency.exchangeRate, num)
    : num;
}

if (typeof window !== "undefined") {
  window["_____getMallUserInfoData"] = getMallUserInfoData;
}
